module.exports = __webpack_public_path__ + "img/jingyingka@3x.d690f26d.svg";